// src/index.ts
var TENANT_GROUP_TYPE = "tenant";
var AnalyticsEvents = {
  // Activation / team
  TEAM_MEMBER_INVITED: "team_member_invited",
  INVITATION_ACCEPTED: "invitation_accepted",
  TEAM_MEMBER_ROLE_UPDATED: "team_member_role_updated",
  TEAM_MEMBER_REMOVED: "team_member_removed",
  // Job setup
  INTAKE_CHAT_STARTED: "intake_chat_started",
  INTAKE_CHAT_COMPLETED: "intake_chat_completed",
  INTAKE_CHAT_ABANDONED: "intake_chat_abandoned",
  JOB_DESCRIPTION_GENERATED: "job_description_generated",
  JOB_DESCRIPTION_UPDATED: "job_description_updated",
  JOB_DETAILS_UPDATED: "job_details_updated",
  // Criteria lifecycle
  CRITERIA_DRAFT_GENERATED: "criteria_draft_generated",
  CRITERIA_SAVED: "criteria_saved",
  CRITERIA_PUBLISHED: "criteria_published",
  CRITERIA_EDITED: "criteria_edited",
  // Sourcing / import
  IMPORT_COMPLETED: "import_completed",
  RESUME_UPLOADED: "resume_uploaded",
  // Pipeline
  MATCH_REPORT_GENERATED: "match_report_generated",
  MATCH_REPORT_FAILED: "match_report_failed",
  RESUME_EXTRACTION_COMPLETED: "resume_text_extraction_completed",
  CANDIDATE_ENRICHED: "candidate_enriched",
  CANDIDATE_ENRICHMENT_FAILED: "candidate_enrichment_failed",
  ENRICHMENT_PROVIDER_DOWN: "enrichment_provider_down",
  ENRICHMENT_NAME_MISMATCH: "enrichment_name_mismatch",
  BL_BAR_SCORED: "bl_bar_scored",
  SCORING_RETRY_REQUESTED: "scoring_retry_requested",
  SCORING_RETRY_FAILED: "scoring_retry_failed",
  // Review / decision
  CANDIDATE_SHORTLISTED: "candidate_shortlisted",
  CANDIDATE_UNSHORTLISTED: "candidate_unshortlisted",
  CANDIDATE_ARCHIVED: "candidate_archived",
  CANDIDATE_UNARCHIVED: "candidate_unarchived",
  REPORT_VIEWED: "report_viewed",
  NOTE_ADDED: "note_added",
  EVIDENCE_ADDED: "evidence_added",
  EVIDENCE_UPDATED: "evidence_updated",
  EVIDENCE_REMOVED: "evidence_removed",
  EVIDENCE_FILE_OPENED: "evidence_file_opened",
  // Feature usage
  TALENT_POOL_FILTERED: "talent_pool_filtered",
  RESUME_OPENED: "resume_opened",
  // Support / help
  SUPPORT_REQUESTED: "support_requested",
  BUG_REPORTED: "bug_reported",
  // Sidebar promos
  SIDEBAR_PROMO_CLICKED: "sidebar_promo_clicked",
  // MCP
  MCP_CANDIDATE_ADDED: "mcp_candidate_added",
  // Chrome extension
  EXTENSION_CANDIDATE_ADDED: "extension_candidate_added",
  EXTENSION_INSTALL_CLICKED: "extension_install_clicked",
  // Criteria insights
  CRITERIA_INSIGHT_VIEWED: "criteria_insight_viewed",
  CRITERIA_INSIGHT_OPENED: "criteria_insight_opened",
  CRITERIA_INSIGHT_FINDING_DECIDED: "criteria_insight_finding_decided",
  CRITERIA_INSIGHT_RESOLVED: "criteria_insight_resolved",
  CRITERIA_INSIGHT_DISMISSED: "criteria_insight_dismissed",
  // Showcases
  SHOWCASE_STARTED: "showcase_started",
  SHOWCASE_STEP_VIEWED: "showcase_step_viewed",
  SHOWCASE_COMPLETED: "showcase_completed"
};
var Features = {
  TEAM_MANAGEMENT: "team_management",
  INTAKE_CHAT: "intake_chat",
  JOB_SETUP: "job_setup",
  HIRING_CRITERIA: "hiring_criteria",
  TALENT_POOL: "talent_pool",
  SCORING: "scoring",
  CANDIDATE_ENRICHMENT: "candidate_enrichment",
  CANDIDATE_REVIEW: "candidate_review",
  SUPPORT: "support",
  SIDEBAR_PROMO: "sidebar_promo",
  MCP: "mcp",
  CHROME_EXTENSION: "chrome_extension",
  SHOWCASE: "showcase",
  CRITERIA_INSIGHTS: "criteria_insights",
  CANDIDATE_EVIDENCE: "candidate_evidence"
};
var EVENT_FEATURE = {
  [AnalyticsEvents.TEAM_MEMBER_INVITED]: Features.TEAM_MANAGEMENT,
  [AnalyticsEvents.INVITATION_ACCEPTED]: Features.TEAM_MANAGEMENT,
  [AnalyticsEvents.TEAM_MEMBER_ROLE_UPDATED]: Features.TEAM_MANAGEMENT,
  [AnalyticsEvents.TEAM_MEMBER_REMOVED]: Features.TEAM_MANAGEMENT,
  [AnalyticsEvents.INTAKE_CHAT_STARTED]: Features.INTAKE_CHAT,
  [AnalyticsEvents.INTAKE_CHAT_COMPLETED]: Features.INTAKE_CHAT,
  [AnalyticsEvents.INTAKE_CHAT_ABANDONED]: Features.INTAKE_CHAT,
  [AnalyticsEvents.JOB_DESCRIPTION_GENERATED]: Features.JOB_SETUP,
  [AnalyticsEvents.JOB_DESCRIPTION_UPDATED]: Features.JOB_SETUP,
  [AnalyticsEvents.JOB_DETAILS_UPDATED]: Features.JOB_SETUP,
  [AnalyticsEvents.CRITERIA_DRAFT_GENERATED]: Features.HIRING_CRITERIA,
  [AnalyticsEvents.CRITERIA_SAVED]: Features.HIRING_CRITERIA,
  [AnalyticsEvents.CRITERIA_PUBLISHED]: Features.HIRING_CRITERIA,
  [AnalyticsEvents.CRITERIA_EDITED]: Features.HIRING_CRITERIA,
  [AnalyticsEvents.IMPORT_COMPLETED]: Features.TALENT_POOL,
  [AnalyticsEvents.RESUME_UPLOADED]: Features.TALENT_POOL,
  [AnalyticsEvents.RESUME_OPENED]: Features.TALENT_POOL,
  [AnalyticsEvents.TALENT_POOL_FILTERED]: Features.TALENT_POOL,
  [AnalyticsEvents.MATCH_REPORT_GENERATED]: Features.SCORING,
  [AnalyticsEvents.MATCH_REPORT_FAILED]: Features.SCORING,
  [AnalyticsEvents.RESUME_EXTRACTION_COMPLETED]: Features.SCORING,
  [AnalyticsEvents.BL_BAR_SCORED]: Features.SCORING,
  [AnalyticsEvents.SCORING_RETRY_REQUESTED]: Features.SCORING,
  [AnalyticsEvents.SCORING_RETRY_FAILED]: Features.SCORING,
  [AnalyticsEvents.CANDIDATE_ENRICHED]: Features.CANDIDATE_ENRICHMENT,
  [AnalyticsEvents.CANDIDATE_ENRICHMENT_FAILED]: Features.CANDIDATE_ENRICHMENT,
  [AnalyticsEvents.ENRICHMENT_PROVIDER_DOWN]: Features.CANDIDATE_ENRICHMENT,
  [AnalyticsEvents.ENRICHMENT_NAME_MISMATCH]: Features.CANDIDATE_ENRICHMENT,
  [AnalyticsEvents.CANDIDATE_SHORTLISTED]: Features.CANDIDATE_REVIEW,
  [AnalyticsEvents.CANDIDATE_UNSHORTLISTED]: Features.CANDIDATE_REVIEW,
  [AnalyticsEvents.CANDIDATE_ARCHIVED]: Features.CANDIDATE_REVIEW,
  [AnalyticsEvents.CANDIDATE_UNARCHIVED]: Features.CANDIDATE_REVIEW,
  [AnalyticsEvents.REPORT_VIEWED]: Features.CANDIDATE_REVIEW,
  [AnalyticsEvents.NOTE_ADDED]: Features.CANDIDATE_REVIEW,
  [AnalyticsEvents.EVIDENCE_ADDED]: Features.CANDIDATE_EVIDENCE,
  [AnalyticsEvents.EVIDENCE_UPDATED]: Features.CANDIDATE_EVIDENCE,
  [AnalyticsEvents.EVIDENCE_REMOVED]: Features.CANDIDATE_EVIDENCE,
  [AnalyticsEvents.EVIDENCE_FILE_OPENED]: Features.CANDIDATE_EVIDENCE,
  [AnalyticsEvents.SUPPORT_REQUESTED]: Features.SUPPORT,
  [AnalyticsEvents.BUG_REPORTED]: Features.SUPPORT,
  [AnalyticsEvents.SIDEBAR_PROMO_CLICKED]: Features.SIDEBAR_PROMO,
  [AnalyticsEvents.MCP_CANDIDATE_ADDED]: Features.MCP,
  [AnalyticsEvents.EXTENSION_CANDIDATE_ADDED]: Features.CHROME_EXTENSION,
  [AnalyticsEvents.EXTENSION_INSTALL_CLICKED]: Features.CHROME_EXTENSION,
  [AnalyticsEvents.SHOWCASE_STARTED]: Features.SHOWCASE,
  [AnalyticsEvents.SHOWCASE_STEP_VIEWED]: Features.SHOWCASE,
  [AnalyticsEvents.SHOWCASE_COMPLETED]: Features.SHOWCASE,
  [AnalyticsEvents.CRITERIA_INSIGHT_VIEWED]: Features.CRITERIA_INSIGHTS,
  [AnalyticsEvents.CRITERIA_INSIGHT_OPENED]: Features.CRITERIA_INSIGHTS,
  [AnalyticsEvents.CRITERIA_INSIGHT_FINDING_DECIDED]: Features.CRITERIA_INSIGHTS,
  [AnalyticsEvents.CRITERIA_INSIGHT_RESOLVED]: Features.CRITERIA_INSIGHTS,
  [AnalyticsEvents.CRITERIA_INSIGHT_DISMISSED]: Features.CRITERIA_INSIGHTS
};
export {
  AnalyticsEvents,
  EVENT_FEATURE,
  Features,
  TENANT_GROUP_TYPE
};
//# sourceMappingURL=index.js.map